// extracted by mini-css-extract-plugin
export var actionButton = "_r8-0";
export var actionMenuContainer = "_r8-i";
export var bubble = "_r8-2";
export var bubbleActionMenu = "_r8-j";
export var bubbleContext = "_r8-6";
export var bubbleItems = "_r8-7";
export var customer = "_r8-3";
export var divider = "_r8-8";
export var fileList = "_r8-9";
export var hiddenComment = "_r8-o";
export var infoAbove = "_r8-a";
export var internal = "_r8-4";
export var lightActionButton = "_r8-1";
export var link = "_r8-b";
export var merchant = "_r8-5";
export var message = "_r8-c";
export var profilePicture = "_r8-e";
export var quillToolbarContainer = "_r8-f";
export var senderDate = "_r8-g";
export var senderDateCustomer = "_r8-h";
export var senderName = "_r8-d";
export var time = "_r8-k";
export var uploadedImage = "_r8-l";
export var username = "_r8-m";
export var xsmall = "_r8-n";